import { LoginResponsePayload } from "../../services/account/login/types";

export const userLogin =
  (response: LoginResponsePayload) => async (dispatch: any) => {
    try {
      dispatch({ type: "LOGIN_SUCCESS", payload: response });
    } catch (error) {
      console.log("error userLogin", error);
    }
  };

export const userLogout = () => async (dispatch: any) => {
  try {
    dispatch({ type: "LOGOUT_SUCCESS" });
  } catch (error) {
    console.log("error userLogout", error);
  }
};
